import React, { useState, useEffect } from 'react';
import { Autocomplete, TextField, FormControlLabel, Checkbox, Box } from '@mui/material';
import walletApi from '../../api/wallet';
import { getErrorMessage } from '../../utils/errors';

const PositionSelector = ({ value, onChange, onError, onBlur, disabled, compact = false }) => {
  const [positions, setPositions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [includeClosed, setIncludeClosed] = useState(false);
  const [search, setSearch] = useState('');

  useEffect(() => {
    const fetchPositions = async () => {
      setLoading(true);
      try {
        const params = new URLSearchParams();
        params.append('include_closed', includeClosed);
        if (search.length >= 2) {
          params.append('search', search);
        }
        const response = await walletApi.get(`/positions/for-selector?${params.toString()}`);
        setPositions(response.data.positions || []);
      } catch (err) {
        if (onError) {
          onError(getErrorMessage(err, 'Falha ao carregar posições.'));
        }
        setPositions([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPositions();
  }, [includeClosed, search, onError]);

  const handleInputChange = (event, newInputValue) => {
    setSearch(newInputValue);
  };

  const handleChange = (event, newValue) => {
    onChange(newValue);
  };

  const handleIncludeClosedChange = (event) => {
    setIncludeClosed(event.target.checked);
  };

  return (
    <Box>
      <Autocomplete
        options={positions}
        getOptionLabel={(option) => option.assetName || ''}
        value={value}
        onChange={handleChange}
        onInputChange={handleInputChange}
        onBlur={onBlur}
        loading={loading}
        disabled={disabled}
        size={compact ? 'small' : 'medium'}
        isOptionEqualToValue={(option, val) => option.id === val?.id}
        renderOption={(props, option) => (
          <li {...props} key={option.id}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <span>{option.assetName}</span>
              {option.assetTicker && (
                <span style={{ color: 'gray', marginLeft: 8 }}>({option.assetTicker})</span>
              )}
            </Box>
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            label={compact ? 'Posicao' : 'Posicao (opcional)'}
            variant="outlined"
            margin={compact ? 'none' : 'normal'}
            fullWidth
            helperText={compact ? undefined : 'Vincular receita a uma posicao de investimento'}
          />
        )}
      />
      {!compact && (
        <FormControlLabel
          control={
            <Checkbox
              checked={includeClosed}
              onChange={handleIncludeClosedChange}
              size="small"
            />
          }
          label="Incluir posicoes encerradas"
          sx={{ mt: -1, mb: 1 }}
        />
      )}
    </Box>
  );
};

export default PositionSelector;
